import { getPollDefaultData } from '@hotjar/common';
/**
 * Set the data for the next item being created for a feature.
 */
angular.module('hjApp').service('NextItemData', [
    'DefaultFeedbackData',
    function (DefaultFeedbackData) {
        const nextData = {
            feedback: { data: null, defaults: DefaultFeedbackData.getData() },
            poll: { data: null, defaults: getPollDefaultData(true) }
        };

        /**
         * Set the data for the next item.
         *
         * @param item String - The key of the item in nextData we want to update.
         * @param data Object - Data to set. Defaults are used for everything else.
         * @param skipDefaultsDeep Boolean - Determine if we want to extend data with the values in DefaultData
         */
        this.set = function (item, data, skipDefaultsDeep) {
            const defaultData = _.cloneDeep(nextData[item].defaults);

            if (skipDefaultsDeep) {
                nextData[item].data = data;
            } else {
                nextData[item].data = _.defaultsDeep(data, defaultData);
            }
        };

        /**
         * Retrieve the data we have available.
         *
         * @param item Item to retrieve data for.
         */
        this.get = function (item) {
            return nextData[item].data;
        };

        /**
         * Clear the next data we have set for an item.
         *
         * @param item Item to clear the data of.
         */
        this.clear = function (item) {
            nextData[item].data = null;
        };
    }
]);
